import type { TARSBarChartTableData } from "../../tars-charts/tarsBarChartHelpers";
import type { FacetTableData } from "./facet-table-helpers";

/** Converts facet table rows (objects) to chart row arrays aligned with headers. */
export function facetTableDataToChartRows(
  table: FacetTableData | null | undefined
): Pick<TARSBarChartTableData, "headers" | "rows"> | null {
  if (!table || table.headers.length === 0 || table.rows.length === 0) return null;
  return {
    headers: table.headers,
    rows: table.rows.map((row) => table.headers.map((header) => row[header] ?? "")),
  };
}
